/* Taste-guide entrances 2026-09-20. No purchase/page_view duplication or new tags. */
(function () {
  'use strict';
  var GUIDE = '/pages/okinawa-amazake-first-taste';
  var VERSION = 'taste_entries_20260920';
  var SOURCES = ['legacy_lp_chura_amazake', 'legacy_lp_chura_amazake_impact', 'main_menu', 'collection_amazake', 'amazake-erabikata', 'amazake-nigate-deai', 'nama-amazake-dokodeutteru', 'pine-amazake-nomikata', 'shikuwasa-amazake-nomikata'];
  var PRODUCTS = ['/products/namakoji', '/products/shikuwasa', '/products/酵素甘酒-パイナップル', '/products/amazake-popular-3set'];
  function legacy(value) { return value === 'legacy_lp_chura_amazake' || value === 'legacy_lp_chura_amazake_impact'; }
  function source(value) { return SOURCES.indexOf(value) !== -1 ? value : 'direct_or_other'; }
  function parsed(href) { try { return new URL(href, location.origin); } catch (e) { return null; } }
  function params(from, slot, destination) {
    return {experiment_id: VERSION, measurement_version: VERSION, creative_slot: slot,
      article_handle: !legacy(from) && from !== 'main_menu' && from !== 'collection_amazake' && from !== 'direct_or_other' ? 'コラム/' + from : '',
      destination: destination, content_type: 'amazake_taste_guide', item_id: 'okinawa-amazake-first-taste',
      entry_source: source(from)};
  }
  function emit(name, values) {
    return !!(window.nuchiFunnelV2 && window.nuchiFunnelV2.emit(name, values));
  }
  function once(name, values, element) {
    var sent = false, attempts = 0;
    function run() {
      if (sent || document.visibilityState !== 'visible') return;
      if (emit(name, values)) {
        sent = true;
        if (element) element.setAttribute('data-taste-measurement', 'emitted');
      } else if (++attempts < 20) setTimeout(run, 500);
    }
    run();
    document.addEventListener('visitorConsentCollected', run);
    document.addEventListener('visibilitychange', run);
  }
  function watch(link, values) {
    if (!window.IntersectionObserver) return;
    var sent = false, inside = false, timer, attempts = 0;
    function check() {
      clearTimeout(timer);
      if (sent || !inside || document.visibilityState !== 'visible') return;
      timer = setTimeout(function () {
        if (inside && document.visibilityState === 'visible' && emit('nuchi_taste_entry_view', values)) {
          sent = true; observer.disconnect();
          link.setAttribute('data-taste-measurement', 'emitted');
        } else if (++attempts < 20) check();
      }, 1000);
    }
    var observer = new IntersectionObserver(function (entries) {
      inside = entries.some(function (e) { return e.target === link && e.intersectionRatio >= .5; }); check();
    }, {threshold: [0, .5]});
    observer.observe(link);
    document.addEventListener('visitorConsentCollected', check);
    document.addEventListener('visibilitychange', check);
  }
  function slot(link) {
    if (link.getAttribute('data-nuchi-taste-entry') === 'collection_amazake') return 'collection_comparison';
    if (link.closest('[data-nuchi-taste-entry]')) return 'article_context';
    if (link.closest('.menu-drawer')) return 'menu_mobile';
    return 'menu_desktop';
  }
  function start() {
    if (document.documentElement.hasAttribute('data-taste-entries-ready')) return;
    document.documentElement.setAttribute('data-taste-entries-ready', VERSION);
    var current = parsed(location.href), from = source(current.searchParams.get('guide_from'));
    var isGuide = current.pathname.replace(/\/$/, '') === GUIDE;
    var body = document.querySelector('#nuchi-tropical-lp');
    document.querySelectorAll('a[href*="/pages/okinawa-amazake-first-taste?guide_from="]').forEach(function (link) {
      var u = parsed(link.href);
      if (!u || u.origin !== location.origin || u.pathname !== GUIDE) return;
      var src = source(u.searchParams.get('guide_from'));
      if (src === 'direct_or_other') return;
      // Keep manual QA identifiable after entry navigation. Never add internal UTMs.
      if (current.searchParams.has('nuchi_qa')) {
        u.searchParams.set('nuchi_qa', current.searchParams.get('nuchi_qa'));
        link.href = u.pathname + u.search + u.hash;
      }
      var data = params(src, slot(link), GUIDE);
      watch(link, data);
      link.addEventListener('click', function () { emit('nuchi_taste_entry_click', data); });
    });
    if (isGuide) {
      once('nuchi_taste_guide_view', params(from, legacy(from) ? 'legacy_lp_fallback' : from === 'main_menu' ? 'menu' : from === 'collection_amazake' ? 'collection_comparison' : from === 'direct_or_other' ? 'direct_or_other' : 'article_context', GUIDE), body);
      // Carry only an allowlisted source label; no internal UTMs, IDs or personal data.
      document.querySelectorAll('a[href*="entry=okinawa-taste-guide"]').forEach(function (link) {
        var u = parsed(link.href);
        if (!u || u.origin !== location.origin || PRODUCTS.indexOf(decodeURIComponent(u.pathname)) === -1) return;
        if (from !== 'direct_or_other') u.searchParams.set('guide_from', from);
        // Preserve QA classification when manually testing the navigation, not the actual source.
        if (current.searchParams.has('nuchi_qa')) u.searchParams.set('nuchi_qa', current.searchParams.get('nuchi_qa'));
        link.href = u.pathname + u.search + u.hash;
        link.addEventListener('click', function () {
          emit('nuchi_taste_product_click', params(from, u.searchParams.get('placement') || 'guide_product', decodeURIComponent(u.pathname)));
        });
      });
    } else if (current.searchParams.get('entry') === 'okinawa-taste-guide' && PRODUCTS.indexOf(decodeURIComponent(current.pathname)) !== -1) {
      once('nuchi_taste_product_arrival', params(from, current.searchParams.get('placement') || 'guide_product', decodeURIComponent(current.pathname)), null);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true}); else start();
})();
